var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonVideoPlayer.jinja');
require('./CommonVideoPlayer.less');

var VimeoPlayer = require('@vimeo/player');

module.exports = Base.extend({

    template: template,

    el: '.CommonVideoPlayer',

    events: {
        'click .CommonVideoPlayer-iframe': 'onOverlayClick'
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onVideoPlaying', 'onVideoPaused', 'onYoutubePlayerAPIReady', 'changeVideo', 'initPlayer', 'pausePlayer');

        Base.prototype.initialize.call(this, options);

        this.$wrapperIframe = this.$('.CommonVideoPlayer-iframe');
        this.$preview = this.$('.CommonVideoPlayer-preview');
        this.$previewImg = this.$('.CommonVideoPlayer-preview img');

        this.curVideo = 0;
        this.duration = 0;
        this.curTime = 0;
        this.delayed = this.$el.attr('data-delayed') == '0' ? false : true;

        if (!this.delayed) {
            this.initPlayer();
        } else {
            this.$el.one('initplayer', this.initPlayer);
        }

        this.$el.on('pauseplayer', this.pausePlayer);


        if (this.options.needNext) {
            this.videos = this.$el.parent().data('videos');
            this.countVideos = this.videos.length;

            window.app.vent.on('CommonVideoGallery-change-video', this.changeVideo);
        }
    },


    onOverlayClick: function (e) {
        e.stopPropagation(); //prevent our custom fullsceen mode on item click

        if (!this.playerIsReady) return;

        var self = this;

        if (this.provider == 'vimeo') {
            this.player.getPaused()
                .then(function (paused) {
                    paused ? self.player.play() : self.player.pause();
                })
                .catch(function (error) {});
        } else {
            this.player.getPlayerState() == 1 ? this.player.pauseVideo() : this.player.playVideo();
        }
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);
    },


    pausePlayer: function () {
        if (!this.playerIsReady) return;

        if (this.provider == 'vimeo') {
            this.player.pause();
        } else {
            this.player.pauseVideo();
        }
    },


    initPlayer: function () {
        this.provider = this.$el.attr('data-provider');

        if (this.delayed) {
            var code = this.$el.find('.CommonVideoPlayer-iframe').attr('data-code');
            code = JSON.parse(code);
            this.$el.find('.CommonVideoPlayer-iframe').html(code);
        }

        this.$iframe = this.$('iframe');

        if (this.provider === 'vimeo') {
            this.player = new VimeoPlayer(this.$iframe[0]);
            this.player.on('play', this.onVideoPlaying);
            this.player.on('pause', this.onVideoPaused);
            this.playerIsReady = true;

            setTimeout(function () {
                this.$('.CommonVideoPlayer-preview').hide();
            }.bind(this), 100);
        }

        if (this.provider === 'youtube') {
            if (window.app.state.youtubePlayerAPIReady) {
                this.onYoutubePlayerAPIReady();
            } else {
                window.app.vent.on('youtube-ready', this.onYoutubePlayerAPIReady);
            }
        }
    },


    onYoutubePlayerAPIReady: function () {
        this.player = new YT.Player(this.$iframe[0], {
            events: {
                'onReady': function (event) {
                    this.youtubePlayerReady = true;

                    this.playerIsReady = true;

                    setTimeout(function () {
                        this.$('.CommonVideoPlayer-preview').hide();
                    }.bind(this), 100);

                    if (this.youtubePlayOnReady) {
                        app.settings.isDesktop && this.player.playVideo();
                    }
                }.bind(this),
                'onStateChange': function (event) {
                    if (event.data == 1) { //playing
                        this.onVideoPlaying();
                    }
                    if (event.data == 2 || event.data == 0) { //pause or ended
                        this.onVideoPaused();
                    }
                }.bind(this)
            }
        });
    },


    changeVideo: function (id) {
        clearInterval(this.idInterval);

        if (this.provider == 'youtube') {
            this.player.stopVideo();
        }

        this.nextVideo(id);
    },


    onVideoPlaying: function () {
        var self = this;

        if (this.options.needNext) {
            if (this.countVideos > 1) {
                if (this.provider == 'vimeo') {
                    this.player.getDuration()
                        .then(function (dur) {
                            self.duration = dur;
                            self.idInterval = setInterval(function () {
                                self.player.getCurrentTime()
                                    .then(function (seconds) {
                                        self.curTime = seconds;
                                    });
                                if (self.duration - self.curTime <= 1) {
                                    clearInterval(self.idInterval);
                                    self.nextVideo(false);
                                }
                            }, 30);
                        });
                }

                if (this.provider == 'youtube') {
                    this.idInterval = setInterval(function () {
                        self.duration = self.player.getDuration();
                        self.curTime = self.player.getCurrentTime();
                        if (self.duration - self.curTime <= 1) {
                            clearInterval(self.idInterval);
                            self.nextVideo(false);
                        }
                    }, 30);
                }
            }
        }
    },


    onVideoPaused: function () {
        if (this.countVideos > 1 && this.options.needNext) {
            clearInterval(this.idInterval);
            delete self.duration;
            delete self.curTime;
        }
    },

    nextVideo: function (id) {

        this.delayed = false;

        if (!id) {
            this.curVideo++;
        } else {
            this.curVideo = id;
        }

        if (this.curVideo < this.countVideos) {
            window.app.vent.trigger('CommonVideoPlayer', this.curVideo);

            if (this.provider == 'vimeo') {
                this.player.pause();
                this.player.off('play', this.onVideoPlaying);
                this.player.off('pause', this.onVideoPaused);
            }

            if (this.provider == 'youtube') {
                this.youtubePlayerReady = false;
                this.player.destroy();
            }

            delete this.player;
            delete this.duration;
            delete this.curTime;

            this.$el.attr('data-provider', this.videos[this.curVideo].provider);

            this.$previewImg.attr('src', this.videos[this.curVideo].cover.w920_url)
                .attr('srcset', this.videos[this.curVideo].cover.w1680_url + ' 1680w, ' +
                    this.videos[this.curVideo].cover.w920_url + ' 920w, ' +
                    this.videos[this.curVideo].cover.w680_url + ' 680w');
            this.$wrapperIframe.html(this.videos[this.curVideo].code);

            this.initPlayer();

            setTimeout(function () {
                if (this.provider == 'vimeo') {
                    app.settings.isDesktop && this.player.play();
                }

                if (this.provider == 'youtube') {
                    if (this.youtubePlayerReady) {
                        app.settings.isDesktop && this.player.playVideo();
                    } else {
                        this.youtubePlayOnReady = true;
                    }
                }
            }.bind(this), 100);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonVideoPlayer/CommonVideoPlayer.js
// module id = 25
// module chunks = 0